import React, { useContext, useEffect, useState } from "react";
import { BuilderContext } from "../BuilderContext";
import { OverlayTrigger, Popover } from "react-bootstrap";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const GlobalFilter = ({
  setselectedAttributes,
  selectedAttributes,
  globalFilter,
  editPage,
  builderDetails,
}) => {
  const { masterdata, setGlobalFilter, selectedAttr } =
    useContext(BuilderContext);
  const [dropDownSelectedAttributes, setdropDownSelectedAttributes] = useState(
    []
  );

  useEffect(() => {
    updateAttributeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterdata]);

  const updateAttributeList = () => {
    if (masterdata) {
      let cat_list = [];
      let attr_list = [];
      let attr_for_cat = [];
      for (let cat in masterdata) {
        attr_for_cat = [];
        cat_list.push({
          label: masterdata[cat]["name"],
          value: masterdata[cat]["id"],
        });
        const cat_attr = masterdata[cat]["attributes"];
        for (let attr in cat_attr) {
          attr_for_cat.push({
            label: cat_attr[attr]["name"],
            value: cat_attr[attr]["id"],
          });
        }
        attr_list.push({
          label: masterdata[cat]["name"],
          options: attr_for_cat,
        });
      }

      if (globalFilter?.length > 0) {
        const uniqueValues = new Set();
        const filteredData = attr_list.reduce((acc, obj) => {
          const matchingOptions = obj.options.filter((opt) =>
            globalFilter?.includes(opt.value)
          );
          if (matchingOptions.length > 0) {
            matchingOptions.forEach((opt) => {
              if (!uniqueValues.has(opt.value)) {
                acc.push({ label: opt.label, value: opt.value });
                uniqueValues.add(opt.value);
              }
            });
          }
          return acc;
        }, []);
        setselectedAttributes(filteredData);
      }
      setdropDownSelectedAttributes(attr_list);
    }
  };

  const updateAttributeSelected = (data) => {
    setselectedAttributes(data);
     let ids = data.map((attr) => attr.value);
     setGlobalFilter(ids);
  };

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      color: "#000",
      minWidth: "215px",
      fontWeight: "500",
      fontSize: "14px",
      shadow: "none",
      height: "36px",
      accentColor: "#091CAA"
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      border: "1px solid #CED4DA",
      width: "fit-content",
      margin: "0px",
      overflowX: "hidden",
      overflowY: "hidden",
      height: "190px"
    }),
    dropdownButton: (provided, state) => ({
      ...provided,
      minWidth: "243px",
      maxWidth: "243px",
      height: "36px",
      color: "#97A0AF",
      fontWeight: "500",
      fontSize: "14px",
      shadow: "none",
      marginRight: "10px",
      rounded: "4px",
      border: `1px solid #C9C9CF`,
      borderRadius: "4px",
      boxShadow: "none"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#EEF0FB" : "white",
      color: state.isSelected ? "#091CAA" : "#333",
      fontWeight: state.isSelected ? "normal" : "500",
      width: "217px",
      alignItems: "center",
      display: "flex"
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      shadow: "none",
      width: "217px",
      
    }),
    control: (provided, state) => ({
      ...provided,
      width: "217px",
      margin: "0px",
    }),
  };

  return (
    <div
      style={{
        background: "#f2f2f2",
        borderColor: "#caccd0",
      }}
      className="builder-border mb-4 pb-2 ps-4 pt-3"
    >
      <div className="filter-title filter-text">
        <label>Pre-filters attribute</label>
      </div>

      <label className="filter-caption filter-text">Attribute</label>
      <div className="row form-group pe-4 pb-4">
        <div className="col-md-12 d-flex align-items-center border-none">
          <ReactMultiSelectCheckboxes
            options={dropDownSelectedAttributes}
            styles={customStyles}
            placeholderButtonLabel={"Select attributes"}
            classNamePrefix="my-multiselect-checkboxes react-multiselect-checkboxes-checkbox"
            className="my-multiselect-checkboxes react-multiselect-checkboxes-checkbox"
            value={selectedAttributes}
            hideSearch={true}
            onChange={(e) => {
              updateAttributeSelected(e);
            }} 
          >
          </ReactMultiSelectCheckboxes>
          <div className="selected-category-items ms-3">
            <div className="d-flex flex-wrap">
              <>
                {selectedAttributes?.length > 0 &&
                  selectedAttributes.map((item, index) => {
                    return (
                      <div className="selected-1 p-2" key={index}>
                        <input
                          type="checkbox"
                          className="btn-check text-white"
                          name="options-outlined"
                          id={`success-outlined${index}`}
                          autoComplete="off"
                          // checked={getChecked(item.id)}
                        />
                        {selectedAttr.findIndex(
                          (attr) => attr.value === item?.value
                        ) === -1 ? (
                          <label
                            className="btn btn-outline-primary-1 btn-sm"
                            htmlFor={`success-outlined`}
                          >
                            {item.label}
                            &nbsp;&nbsp;
                            <span
                              className="new-close-icon"
                              onClick={() => {
                                let itemArray = [...selectedAttributes];
                                itemArray.splice(index, 1);
                                setselectedAttributes(itemArray);
                                let ids = itemArray.map((attr) => attr.value);
                                setGlobalFilter(ids);
                              }}
                            >
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 19 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14 5L5 14"
                                  stroke="#091CAA"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M5 5L14 14"
                                  stroke="#091CAA"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </label>
                        ) : (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Popover id="popover-basic">
                                <Popover.Body>
                                Filter is being used in one or more components below.
                                </Popover.Body>
                              </Popover>
                            }
                          >
                            <label
                              className="unselected-category"
                              htmlFor={`success-outlined${item.id}`}
                            >
                              {item?.label}
                              &nbsp;&nbsp;
                            </label>
                          </OverlayTrigger>
                        )}
                      </div>
                    );
                  })}
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GlobalFilter;
